import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoal = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.26196 9.89429L12.3872 6.76904",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3872 6.769L12.8132 3.9565L15.2492 1.5625L15.6257 3.5305L17.5937 3.907L15.1997 6.343L12.3872 6.769Z",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7912 8.13478C17.1887 9.64158 17.0944 11.236 16.5221 12.6854C15.9499 14.1349 14.9295 15.3636 13.6099 16.1924C12.2902 17.0213 10.7403 17.4068 9.18612 17.2929C7.63195 17.1791 6.1548 16.5716 4.97009 15.5593C3.78537 14.5469 2.95504 13.1825 2.60019 11.6651C2.24534 10.1477 2.38452 8.55666 2.99744 7.12391C3.61035 5.69116 4.66495 4.49168 6.00744 3.70039C7.34993 2.90909 8.9101 2.56736 10.4604 2.72503",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5415 9.05275C13.7388 9.84827 13.6829 10.6855 13.3818 11.4478C13.0806 12.2101 12.5491 12.8594 11.8614 13.3053C11.1737 13.7512 10.3639 13.9713 9.54513 13.9352C8.72631 13.899 7.93918 13.6082 7.29346 13.1034C6.64774 12.5986 6.17561 11.9049 5.94287 11.119C5.71014 10.3332 5.72839 9.49425 5.9951 8.71923C6.2618 7.94422 6.76367 7.27173 7.43074 6.7955C8.09781 6.31927 8.89684 6.06303 9.71646 6.0625",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.88696 16.1875L5.32446 18.4375",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.762 16.1875L14.3245 18.4375",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgGoal);
export default ForwardRef;
